'use client';

import { usePathname } from 'next/navigation';

import { WEL_MARKET_ROUTES } from '@/constants';
import { useAdpopcorn } from '@/modules/adpopcorn';
import { gtmDatasets } from '@/utils/analytics/gtm';

export const WelloPointTabItem = () => {
  const pathname = usePathname();
  const isWelmarket = pathname.startsWith(WEL_MARKET_ROUTES.HOME.pathname);
  const placement = isWelmarket ? 'BOTTOM_NAV_WELMARKET' : 'BOTTOM_NAV';

  const { status, onClick, isOpening } = useAdpopcorn({ placement });

  if (status === 'unsupported') return null;

  const clickFnbDataset = gtmDatasets.clickFnb({ menu_name: '혜택' });

  return (
    <button
      type="button"
      {...clickFnbDataset}
      onClick={onClick}
      disabled={isOpening}
      className="relative w-full flex-col gap-5 whitespace-nowrap font-500 text-Gray-550 flex-center typo-caption1 disabled:opacity-60"
    >
      <div className="relative">
        <svg
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
          className="size-28"
        >
          <path
            d="M14 2.33334C20.4327 2.3335 25.665 7.56632 25.665 13.9994C25.665 20.4324 20.4327 25.6652 14 25.6654C12.326 25.6654 10.6389 25.293 9.12402 24.5882C8.82622 24.4459 8.45627 24.4363 8.07715 24.557L5.09863 25.558C4.8773 25.6309 4.652 25.6663 4.43066 25.6664C3.88383 25.6664 3.35225 25.4512 2.9502 25.0492C2.38318 24.4832 2.1882 23.6608 2.43945 22.9046L3.44531 19.9124C3.56258 19.5451 3.55265 19.1759 3.41504 18.8851C2.70667 17.3618 2.33496 15.6746 2.33496 13.9994C2.335 7.56743 7.56839 2.33334 14 2.33334ZM13.999 8.31674C13.4235 8.31674 12.9062 8.63737 12.6514 9.15073L11.6318 11.2005L9.26855 11.5404C8.71217 11.6206 8.25944 12.0026 8.08594 12.5374C7.91267 13.071 8.05683 13.6445 8.45996 14.0345L10.1631 15.682L9.77539 17.9271C9.67744 18.4918 9.90498 19.0543 10.3691 19.3929C10.8345 19.7327 11.4435 19.7777 11.9531 19.5111L13.9971 18.4447L16.042 19.5121C16.2634 19.6269 16.5021 19.6849 16.7402 19.6849C17.0524 19.6848 17.3614 19.5863 17.627 19.3949C18.091 19.0562 18.3196 18.4961 18.2227 17.929L17.834 15.682L19.5371 14.0345C19.939 13.6445 20.0844 13.071 19.9111 12.5374C19.7388 12.0025 19.2849 11.6205 18.7285 11.5404L16.3652 11.2005L15.3457 9.15073C15.0897 8.63631 14.5732 8.31692 13.999 8.31674Z"
            fill="#D1D5DD"
          />
        </svg>
      </div>
      혜택
    </button>
  );
};
